import { useMemo } from "react";

type UserAttrs = {
	id: string;
};

export default function useSplitUsersIntoOthers<User extends UserAttrs>(
	users: readonly User[],
	selfId: string,
	maxLength: number,
	omitSelf: boolean,
) {
	return useMemo(() => {
		const filteredUsers = omitSelf ? users.filter(user => user.id !== selfId) : users;

		const usersToShow = filteredUsers.slice(0, maxLength);
		const hiddenUsers = filteredUsers.slice(maxLength);
		return { usersToShow, hiddenUsers };
	}, [users, maxLength, omitSelf, selfId]);
}
